import { ModalTrigger } from '@arivaa-react/components/modal';
import { Button, Tooltip } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { PopoverContent } from './linkDomainPopover';
import './style.css';

export const LinkDomainForm = () => {
  return (
    <ModalTrigger
      modalProps={{
        title: 'Link domain',
        footer: null,
        destroyOnHidden: true,
      }}
      content={<PopoverContent className="large-modal" />}
    >
      <Tooltip title="Link Domain" placement="bottom">
        <Button className="btn blue-btn-text">
          <LinkOutlined /> Domain
        </Button>
      </Tooltip>
    </ModalTrigger>
  );
};
